import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReviewsSection = ({ reviews, averageRating, totalReviews }) => {
  const [filter, setFilter] = useState('all');

  const ratingDistribution = [
    { stars: 5, count: 145, percentage: 72 },
    { stars: 4, count: 38, percentage: 19 },
    { stars: 3, count: 12, percentage: 6 },
    { stars: 2, count: 4, percentage: 2 },
    { stars: 1, count: 2, percentage: 1 }
  ];

  const filteredReviews = filter === 'all' 
    ? reviews 
    : reviews?.filter(review => review?.rating === parseInt(filter));

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('tr-TR', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-lg font-semibold text-foreground mb-6">Değerlendirmeler ve Yorumlar</h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
        <div className="lg:col-span-1 p-6 bg-muted rounded-lg text-center">
          <p className="text-5xl font-bold text-foreground mb-2">{averageRating}</p>
          <div className="flex items-center justify-center gap-1 mb-2">
            {[1, 2, 3, 4, 5]?.map((star) => (
              <Icon
                key={star}
                name="Star"
                size={20}
                color={star <= Math.round(averageRating) ? 'var(--color-accent)' : 'var(--color-muted-foreground)'}
                className={star <= Math.round(averageRating) ? 'fill-current' : ''}
              />
            ))}
          </div>
          <p className="text-sm text-muted-foreground">{totalReviews} değerlendirme</p>
        </div>

        <div className="lg:col-span-2 space-y-2">
          {ratingDistribution?.map((item) => (
            <div key={item?.stars} className="flex items-center gap-3">
              <div className="flex items-center gap-1 w-16">
                <span className="text-sm font-medium text-foreground">{item?.stars}</span>
                <Icon name="Star" size={14} color="var(--color-accent)" className="fill-current" />
              </div>
              <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-accent rounded-full transition-all"
                  style={{ width: `${item?.percentage}%` }}
                />
              </div>
              <span className="text-sm text-muted-foreground w-12 text-right">{item?.count}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-6">
        <Button
          variant={filter === 'all' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setFilter('all')}
        >
          Tümü
        </Button>
        {[5, 4, 3, 2, 1]?.map((rating) => (
          <Button
            key={rating}
            variant={filter === rating?.toString() ? 'default' : 'outline'}
            size="sm"
            onClick={() => setFilter(rating?.toString())}
          >
            {rating} Yıldız
          </Button>
        ))}
      </div>
      <div className="space-y-4">
        {filteredReviews?.map((review) => (
          <div key={review?.id} className="p-4 bg-muted rounded-lg">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-background flex-shrink-0">
                <Image
                  src={review?.avatar}
                  alt={review?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <div>
                    <p className="font-medium text-foreground">{review?.name}</p>
                    <p className="text-sm text-muted-foreground">{review?.role}</p>
                  </div>
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5]?.map((star) => (
                      <Icon
                        key={star}
                        name="Star"
                        size={14}
                        color={star <= review?.rating ? 'var(--color-accent)' : 'var(--color-muted-foreground)'}
                        className={star <= review?.rating ? 'fill-current' : ''}
                      />
                    ))}
                  </div>
                </div>

                <p className="text-sm text-foreground mb-2">{review?.comment}</p>

                {review?.campaign && (
                  <div className="inline-flex items-center gap-2 px-3 py-1 bg-background rounded-md text-xs text-muted-foreground mb-2">
                    <Icon name="Briefcase" size={12} />
                    <span>{review?.campaign}</span>
                  </div>
                )}

                <div className="flex items-center justify-between">
                  <p className="text-xs text-muted-foreground">{formatDate(review?.date)}</p>
                  {review?.verified && (
                    <span className="inline-flex items-center gap-1 text-xs text-success">
                      <Icon name="CheckCircle" size={12} />
                      Doğrulanmış Alıcı
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSection;